unit uLockerStorageBinding;

// Storage-side binding: HTTP transport + JSON <--> Buffer mapping
// No UI references anywhere in this unit

interface

uses
  System.SysUtils, System.Classes, System.StrUtils,
  WEBLib.REST, WEBLib.JSON, JS, Web,
  uLockerController, uLockerContracts;

const
  FIELD_NAME_MAP : array of string = [
    'Locker ID:lockerID',
    'Name:name',
    'Title:title',
    'Description:description',
    'How to use:how_to_use_this',
    'Help Text:get_help_text',
    'Help URL:get_help_url',
    'Source:source',
    'Author:author',
    'Price:price',
//    'Difficulty:difficulty_level',
    'AI Platform:ai_platform_default',
    'AI Model:ai_model_default',
    'Temperature:ai_temperature',
    'Max Tokens:ai_max_tokens',
    'Output Format:output_format',
    'Tags:tags',
    'Parameters:parameters',
    'AI Prompt:ai_prompt',
    'Version:version',
    'Created:created_at',
    'Last Edited:last_edited_at',
    'Executions:execution_count',
    'Last Executed:last_executed_at',
    'Total Sales $:total_revenue'
  ];

type
  TLockerStorageBinding = class(TAbstractStorageBinding)
  private
    FMetadataJSON : TJSONObject;  // kept for SetupLockerUI and prompt-changed diff on save
    FPromptJSON   : TJSONObject;
  public
    constructor Create;

    // '' = ok, else error msg
    [async] function LoadBufferFromStorage(const aLockerID: string; aBuffer: TStringlist): string; async; override;
    [async] function SendBufferToStorage(const aLockerID: string; aBuffer: TStringlist): string; async; override;

    function MetadataJSON : TJSONObject; override;
    function PromptJSON   : TJSONObject; override;
  end;

implementation

uses uConstants;

//===============================================================
constructor TLockerStorageBinding.Create;
//===============================================================
begin
//
end;

//===============================================================
function TLockerStorageBinding.MetadataJSON: TJSONObject;
//===============================================================
begin
  Result := FMetadataJSON;
end;

//===============================================================
function TLockerStorageBinding.PromptJSON: TJSONObject;
//===============================================================
begin
  Result := FPromptJSON;
end;

//===============================================================
function TLockerStorageBinding.LoadBufferFromStorage(const aLockerID: string; aBuffer: TStringlist): string;
//===============================================================
// Load:  Widgets <-- Buffer <-- Storage
// Fetches metadata + prompt JSON, flattens both into aBuffer.
// Returns '' on success, error message on failure.
var
  Request          : THTTPRequest;
  req              : TJSXMLHttpRequest;
  MetadataResponse : TJSONObject;
  PromptsResponse  : TJSONObject;
  //------------------------------------
  function JVal(const aKey: string): string; inline;
  begin
    Result := _JSON_VAL_STR(MetadataResponse, aKey);
  end;
  //------------------------------------
begin
  Result := '';

  if Trim(aLockerID) = '' then
  begin
    Result := 'No Locker selected';
    Exit;
  end;

  aBuffer.Clear;

  // Fetch metadata
  Request         := THTTPRequest.Create(nil);
  Request.URL     := LOCKER_METADATA_API_URL + '?lockerID=' + aLockerID;
  Request.Command := httpGET;
  Request.Headers.AddPair('X-API-Key', LOCKER_STORAGE_API_KEY);

  req := await(TJSXMLHttpRequest, Request.Perform());

  if req.Status <> 200 then
  begin
    Result := 'Error fetching metadata: ' + IntToStr(req.Status) + ' ' + req.statusText;
    Exit;
  end;

  FMetadataJSON    := TJSONObject.ParseJSONValue(string(req.Response)) as TJSONObject;
  MetadataResponse := FMetadataJSON;

  // Scalar fields --> buffer
  aBuffer.Values['Locker ID:lockerID']              := aLockerID;
  aBuffer.Values['Name:name']                       := JVal('name');
  aBuffer.Values['Title:title']                     := JVal('title');
  aBuffer.Values['Description:description']         := JVal('description');
  aBuffer.Values['How to use:how_to_use_this']      := JVal('how_to_use_this');
  aBuffer.Values['Version:version']                 := JVal('version');
  aBuffer.Values['Price:price']                     := JVal('price');
  aBuffer.Values['Source:source']                   := JVal('source');
  aBuffer.Values['Author:author']                   := JVal('author');
  aBuffer.Values['AI Platform:ai_platform_default'] := JVal('ai_platform_default');
  aBuffer.Values['AI Model:ai_model_default']       := JVal('ai_model_default');
  aBuffer.Values['Temperature:ai_temperature']      := JVal('ai_temperature');
  aBuffer.Values['Max Tokens:ai_max_tokens']        := JVal('ai_max_tokens');
  aBuffer.Values['Output Format:output_format']     := JVal('output_format');
  aBuffer.Values['Help Text:get_help_text']         := JVal('get_help_text');
  aBuffer.Values['Help URL:get_help_url']           := JVal('get_help_url');


  // Misc fields --> buffer
  aBuffer.Values['Source:source']                   := JVal('source');
  aBuffer.Values['Author:author']                   := JVal('author');
  aBuffer.Values['Price:price']                     := JVal('price');
  aBuffer.Values['Tags:tags']                       := MetadataResponse.GetValue('tags').ToString;
//  aBuffer.Values['Difficulty:difficulty_level']     := JVal('difficulty_level');

  // Metrics fields --> buffer
  aBuffer.Values['Version:version']                 := JVal('version');
  aBuffer.Values['Created:created_at']              := JVal('created_at');
  aBuffer.Values['Last Edited:last_edited_at']      := JVal('last_edited_at');
  aBuffer.Values['Executions:execution_count']      := JVal('execution_count');
  aBuffer.Values['Last Executed:last_executed_at']  := JVal('last_executed_at');
  aBuffer.Values['Total Sales $:total_revenue']     := JVal('total_revenue');


  // Array fields as raw JSON strings --> buffer
  aBuffer.Values['Parameters:parameters']           := MetadataResponse.GetValue('parameters').ToString;

  // Fetch prompt
  Request.URL := LOCKER_PROMPTS_API_URL + '?lockerID=' + aLockerID;
  req := await(TJSXMLHttpRequest, Request.Perform());

  if req.Status = 200 then
  begin
    PromptsResponse             := TJSONObject.ParseJSONValue(string(req.Response)) as TJSONObject;
    FPromptJSON                 := PromptsResponse;
    aBuffer.Values['AI Prompt:ai_prompt']           := PromptsResponse.GetValue('ai_prompt').Value;
  end
  else
    aBuffer.Values['ai_prompt'] := '';
end;

//===============================================================
function TLockerStorageBinding.SendBufferToStorage(const aLockerID: string; aBuffer: TStringlist): string;
//===============================================================
// Save:  Widgets --> Buffer --> Storage
// Rebuilds metadata JSON from buffer and PUTs to metadata API.
// Only POSTs to prompts API if ai_prompt differs from fetched original.
  //------------------------------------
  function BufVal(const aKey: string; const aDflt: string = ''): string;
  var
    i     : integer;
    parts : TStringArray;
  begin
    Result := aDflt;
    for i := 0 to aBuffer.Count-1 do
    begin
      parts := aBuffer.Names[i].Split([':']);
      if (parts[1] = aKey) then
        Exit( Trim(aBuffer.ValueFromIndex[i]) );
    end;
  end;
  //------------------------------------
var
  Request    : THTTPRequest;
  req        : TJSXMLHttpRequest;
  MetaObj    : TJSONObject;
  ParamsArr  : TJSONArray;
  TagsArr    : TJSONArray;
  PromptObj  : TJSONObject;
  OrigPrompt : string;
  s          : string;
  i          : integer;

begin
  Result := '';

  MetaObj := TJSONObject.Create;

  MetaObj.AddPair('lockerID', TJSONString.Create(aLockerID));
  for i := 0 to LockerFieldNames.Count-1 do
  begin
    // these use the Internal names
    s := LockerFieldNames.ValueFromIndex[i];
    if MatchText( s, ['lockerID', 'tags', 'parameters', 'ai_prompt'] ) then
      Continue;
    MetaObj.AddPair(s, TJSONString.Create(BufVal(s)));
  end;


  // Tags — parse JSON array string back to TJSONArray
  s := BufVal('tags');
  if (s = '') then
    s := '[]';
  TagsArr := TJSONObject.ParseJSONValue(s) as TJSONArray;
  if not Assigned(TagsArr) then
    TagsArr := TJSONArray.Create;
  MetaObj.AddPair('tags', TagsArr);

  // ?? Parameters — parse JSON array string back to TJSONArray ??
  s := BufVal('parameters');
  if (s = '') then
    s := '[]';
  ParamsArr := TJSONObject.ParseJSONValue(s) as TJSONArray;
  if not Assigned(ParamsArr) then
    ParamsArr := TJSONArray.Create;
  MetaObj.AddPair('parameters', ParamsArr);

  // PUT metadata
  Request         := THTTPRequest.Create(nil);
  Request.URL     := LOCKER_METADATA_API_URL + '?lockerID=' + aLockerID;
  Request.Command := httpPUT;
  Request.Headers.AddPair('X-API-Key',    LOCKER_STORAGE_API_KEY);
  Request.Headers.AddPair('Content-Type', 'application/json');
  Request.PostData := MetaObj.ToJSON;

// console.log('PUT payload:' + MetaObj.ToJSON());   // ###

  req := await(TJSXMLHttpRequest, Request.Perform());

  if req.Status <> 200 then
  begin
    Result := 'Error saving metadata: ' + IntToStr(req.Status) + ' ' + req.statusText;
    console.log('  Status: ' + IntToStr(req.Status) + ' ' + req.statusText);   // ###
    console.log('  Response: ' + string(req.response));   // ###
    Exit;
  end;

  // POST prompt only if it changed
  OrigPrompt := '';
  if Assigned(FPromptJSON) then
    OrigPrompt := _JSON_VAL_STR(FPromptJSON, 'ai_prompt');

  if BufVal('ai_prompt') <> OrigPrompt then
  begin
    PromptObj := TJSONObject.Create;
    PromptObj.AddPair('lockerID', TJSONString.Create(aLockerID));
    PromptObj.AddPair('ai_prompt', TJSONString.Create(BufVal('ai_prompt')));

    Request.URL      := LOCKER_PROMPTS_API_URL + '?lockerID=' + aLockerID;
    Request.PostData := PromptObj.ToJSON;

    req := await(TJSXMLHttpRequest, Request.Perform());

    if req.Status <> 200 then
    begin
      Result := 'Error saving prompt: ' + IntToStr(req.Status) + ' ' + req.statusText;
    end;
  end;
end;

initialization
  if not Assigned(LockerFieldNames) then
    LockerFieldNames := TStringList.Create;

  LockerFieldNames.NameValueSeparator := ':';
  LockerFieldNames.AddStrings(FIELD_NAME_MAP);

end.
